module.exports = __webpack_public_path__ + "static/media/blueth-bind.b4fce5e.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/blueth-bind.mp4
// module id = 9P0d
// module chunks = 0